<template>
    <div class="review-container__wrapper">
      <div class="review-container">
        <div class="review-cover">
          <img src="https://storage.googleapis.com/usavina/salonaz/admin/image/upload/1729146239559" alt="cover image" />
        </div>
        <div class="review-website">
          www.aventusnailspa.com
        </div>
        <div class="social-media-container">
          <div class="social-icons">
            <a href="#" target="_blank"><i class="fab fa-twitter"></i></a>
            <a href="#" target="_blank"><i class="fab fa-facebook"></i></a>
            <a href="#" target="_blank"><i class="fab fa-instagram"></i></a>
            <a href="#" target="_blank"><i class="fab fa-tiktok"></i></a>
            <a href="#" target="_blank"><i class="fab fa-pinterest"></i></a>
            <a href="#" target="_blank"><i class="fab fa-youtube"></i></a>
          </div>
          <div class="social-username">
            @AventusNailSpa
          </div>
        </div>
        <div class="review-content">
          <div class="review-content-first">
            Hi, {{ ticketData ? ticketData.customer.full_name : "" }} How would you rate your most recent service?
          </div>
        </div>
        <div class="rating-container">
          <div class="star-container">
            <div
              v-for="(item, index) in ratingStar"
              :key="index"
              class="star normal-button"
              @click="ratingNumber = index + 1"
            >
              <img v-if="item" src="@/assets/star_fill.svg" />
              <img v-else src="@/assets/star.svg" />
            </div>
          </div>
        </div>
        <div class="review-google-description">
          <div class="title">Show Us Some Love! Win Big!</div>
          <div class="subtitle">
            Your review enters you in for a chance to win a&nbsp;
            <el-tooltip class="item" placement="top">
              <div
                slot="content"
                style="width: 330px; line-height: 22px; font-size: 14px"
              >
                <span
                  >Win a $300 VIP spa gift card.<br /><br />Thanks so much for visiting
                  our salon. How did we do? Please leave us a review to let us
                  know. Your review not only helps us, it helps other potential
                  customers. It takes only a moment and would mean the world to
                  us.<br /><br />Your review enters you in for a chance to win a
                  $300 VIP spa gift card. Four lucky winners will be announced at the end
                  of each quarter (March 31st, June 30th, September 30th &
                  December 31st). That's 16 winners in total for the year! Are you
                  feeling lucky? Enter below now.</span
                >
              </div>
              <span class="bold-text underline-text highlight-text"
                >$300 VIP spa gift card</span
              >
            </el-tooltip>
          </div>
        </div>
        <div
          class="complain-container"
          v-show="ratingNumber > 0 && ratingNumber <= 4"
        >
          <textarea
            class="review-area"
            placeholder="Please share your feedback to help us getting better"
            v-model="reviewContent"
          />
          <input
            v-if="ticketId == ''"
            type="tel"
            class="review-input"
            placeholder="Phone"
            v-model="reviewPhone"
          />
          <input
            v-if="ticketId == ''"
            type="email"
            class="review-input"
            placeholder="Email (optional)"
            v-model="reviewEmail"
          />
          <div v-else style="height: 40px" />
          <div class="btn-submit normal-button" @click="onSubmitReview">
            <span>Submit</span>
          </div>
        </div>
        <div class="review-google-container" v-show="ratingNumber >= 4">
          <div class="login-google-button normal-button" @click="loginGoogle">
            <img src="@/assets/ic_google.svg" />
            <span class="login-text">Sign in with Google</span>
          </div>
        </div>
        <div class="review-des">
          <div>We strive to provide the best service. For any questions or concerns,</div>
          <div>speak with the manager or call 614-618-9999</div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { getDisplayName, findTicketById, addReview } from "@/api/home";
  import { Message } from "element-ui";
  export default {
    data() {
      return {
        ratingNumber: 0,
        storeData: {},
        storeName: "",
        ticketId: "",
        windowWidth: Math.min(600, window.innerWidth),
        ticketData: null,
        reviewContent: "",
        reviewPhone: "",
        reviewEmail: "",
        giftContent: `Win a $300 VIP spa gift card\nThanks so much for visiting our salon. How did we do? Please leave us a review to let us know. Your review not only helps us, it helps other potential customers. It takes only a moment and would mean the world to us.\nYour review enters you in for a chance to win a $300 VIP spa gift card. Four lucky winners will be announced at the end of each quarter (March 31st, June 30th, September 30th & December 31st). That's 16 winners in total for the year! Are you feeling lucky? Enter below now.`,
      };
    },
    methods: {
      async onSubmitReview() {
        const body = {
          review_score: this.ratingNumber,
          review_content: this.reviewContent,
          store_name: this.storeName,
          phone_number: this.reviewPhone,
          email: this.reviewEmail
        };
        if (this.ticketId) {
          body.ticket_id = this.ticketId;
          body.user_id = this.ticketData.customer.user_id;
        }
        await addReview(body);
        Message({
          message: "Thank you for your review",
          type: "success",
          duration: 2 * 1000,
          onClose: () => {
            // window.location.href = "https://www.avnailscolumbus.com/";
            window.location.href = this.storeData.store_url || "https://www.avnailscolumbus.com/";
          },
        });
      },
      async messageReceive(event) {
        if (event.origin == "https://accounts.google.com") {
          const { authResult } = JSON.parse(event.data).params;
          const body = {
            review_score: this.ratingNumber,
            google_auth: {
              id_token: authResult.id_token,
            },
            store_name: this.storeName,
            phone_number: this.reviewPhone,
          };
          if (this.ticketId) {
            body.ticket_id = this.ticketId;
            body.user_id = this.ticketData.customer.user_id;
          }
          await addReview(body);
          window.location.href =
            this.storeData.google_review_url || "https://www.google.com/";
        }
      },
      loginGoogle() {
        let top = window.screen.height - 600;
        top = top > 0 ? top / 2 : 0;
  
        let left = window.screen.width - 600;
        left = left > 0 ? left / 2 : 0;
        // const redirect_uri = "localhost:8080";
        // const scheme = "http";
        const redirect_uri = process.env.VUE_APP_BASE_URL;
        const scheme = "https";
        window.open(
          `https://accounts.google.com/o/oauth2/auth/oauthchooseaccount?redirect_uri=storagerelay%3A%2F%2F${scheme}%2F${redirect_uri}%3Fid%3Dauth669654&response_type=code%20permission%20id_token&scope=profile%20email%20openid&openid.realm&client_id=107185410564-bdf4qb8qos09mkbpues94mfl13skomrs.apps.googleusercontent.com&ss_domain=${scheme}%3A%2F%2F${redirect_uri}&access_type=offline&include_granted_scopes=true&prompt=consent&origin=${scheme}%3A%2F%2F${redirect_uri}&gsiwebsdk=2&flowName=GeneralOAuthFlow`,
          "popup",
          "width=600,height=600" + ",top=" + top + ",left=" + left
        );
      },
      onResize() {
        this.windowWidth = Math.min(600, window.innerWidth);
      },
    },
    mounted() {
      this.$nextTick(() => {
        window.addEventListener("resize", this.onResize);
      });
        const getBrandName = (storeType) => {
            if (storeType === 'av') return `Anthony Vince' Nail Spa`;
            if (storeType === 'mv') return `M. Vince' Nail Spa`;
            if (storeType === 'pns') return `Prive Nail Spa`;
            if (storeType === 'vns') return `Venetian Nail Spa`;
            return `Anthony Vince' Nail Spa`;
        };
        console.log(getBrandName(null))

    },
  
    beforeDestroy() {
      window.removeEventListener("resize", this.onResize);
    },
    computed: {
      technician() {
        if (!this.ticketData || this.ticketData.user_assign.length == 0) {
          return "Anyone";
        }
        return this.ticketData.user_assign
          .map((u) => u.user.full_name)
          .join(", ");
      },
      ratingStar() {
        let res = [false, false, false, false, false];
        res = res.map((_, index) => index < this.ratingNumber);
        return res;
      },
      imgHeight() {
        return this.windowWidth / 3;
      },
      device() {
        return this.$store.state.app.device;
      },
      isMobile() {
        if (
          /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
          )
        ) {
          return true;
        } else {
          return false;
        }
      },
      dialogWidth() {
        if (this.isMobile) return "100%";
        return "600px";
      },
    },
    created() {
      this.ticketId = this.$route.query.ticket_id || "";
      if (this.ticketId) {
        findTicketById(this.ticketId).then((res) => {
          this.ticketData = res;
          this.storeName = res.store;
          getDisplayName(this.storeName).then((res) => {
            this.storeData = res;
          });
        });
      } else {
        this.storeName = this.$route.query.storename;
        getDisplayName(this.storeName).then((res) => {
          this.storeData = res;
        });
      }
      window.removeEventListener("message", this.messageReceive);
      window.addEventListener("message", this.messageReceive, false);
    },
  };
  </script>
  
  <style lang="scss">
  .review-container {
    .el-dialog__close {
      font-size: 30px !important;
    }
  }
  </style>
  
  <style lang="scss" scoped>
  .review-container__wrapper {
    padding-left: calc(50% - 300px);
    padding-right: calc(50% - 300px);
  }
  .store-cover {
    object-fit: cover;
  }
  .review-container {
    background-image: url('https://storage.googleapis.com/usavina/salonaz/admin/image/upload/1729222007364');
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center; 
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    flex-direction: column;
    padding-left: 0px;
    padding-right: 0px;
    width: 100%;
    overflow: visible;
    .review-cover {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
      margin-top: 400px;
    }
    .review-cover img {
      width: 100%;
      height: 100%;
      object-fit: cover; /* Giúp ảnh lấp đầy mà không bị biến dạng */
    }
    .review-website {
      display: flex;
      width: 100%;
      height: 40px;
      align-items: center;
      justify-content: center;
      color: white;
      background-color: #222222;
      font-family: 'Montserrat', sans-serif;
      font-weight: 600;
    }
    .social-media-container {
      text-align: center;
      margin-top: 20px;
    }
    
    .social-icons a {
      text-decoration: none;
      margin: 0 10px;
      color: #000;
      font-size: 30px;
      transition: color 0.3s ease;
    }
    
    .social-icons a:hover {
      color: #666;
    }
    
    .social-username {
      margin-top: 10px;
      color: #000;
      font-family: 'Montserrat', sans-serif;
      font-weight: 600;
    }
    .review-content {
      display: flex;
      white-space: nowrap;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
      font-weight: 600;
      font-size: 14px;
      line-height: 24px;
      color: black;
      align-self: center;
      padding: 40px 30px 0 30px;
    }
    .review-google-description {
      font-weight: 600;
      color: #5f5f5f;
      font-size: 14px;
      line-height: 23px;
      padding: 0 20px;
      margin-top: 30px;
      text-align: center;

      .title {
        font-size: 16px;
        font-weight: 700;
        margin-bottom: 10px;
      }

      .subtitle {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        white-space: nowrap;
      }

      .bold-text {
        font-weight: 700;
        color: #222222;
      }

      .underline-text {
        text-decoration: underline;
      }

      .highlight-text {
        font-size: 18px;
      }

      /* Thêm khoảng cách cho el-tooltip */
      .item {
        margin-left: 4px; /* Khoảng cách giữa "a" và "$300" */
      }

      /* Responsive cho mobile */
      @media (max-width: 768px) {
        .subtitle {
          flex-direction: column;
          text-align: center;
        }

        .bold-text {
          margin-top: 5px;
        }

        .item {
          margin-left: 0; /* Bỏ margin-left trên mobile vì đã xuống hàng */
        }
      }

      /* Responsive cho desktop */
      @media (min-width: 769px) {
        .subtitle {
          flex-direction: row;
          flex-wrap: nowrap;
        }
      }
    }
    .rating-container {
      display: flex;
      flex-direction: column;
      margin-top: 40px;
      align-items: center;
      justify-content: center;
      .star-container {
        display: flex;
        align-items: center;
        .star {
          margin: 0 7.5px;
        }
      }
      .ticket-info {
        font-weight: 600;
        font-size: 14px;
        color: black;
      }
    }
    .review-google-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      align-self: center;
      margin-top: 60px;
      .login-google-button {
        width: 335px;
        height: 60px;
        border-radius: 5px;
        background-color: white;
        display: flex;
        align-items: center;
        padding: 0 30px;
        .login-text {
          font-weight: 600;
          font-size: 18px;
          color: #222222;
          margin-left: 21px;
        }
      }
      .content-gift {
        line-height: 29px;
      }
    }
    .review-des {
      margin-top: 50px;
      padding-bottom: 50px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-weight: 600;
      font-size: 10px;
      font-style: italic;
      line-height: 18px;
      color: #c7a57e;
    }
    .complain-container {
      display: flex;
      flex-direction: column;
      width: 100%;
      .review-area {
        border: none;
        margin: 50px 32px 0px 32px;
        padding: 20px;
        height: 130px;
        resize: none;
        font-weight: 500;
        font-size: 16px;
      }
      .review-input {
        border: none;
        margin: 20px 32px 0px 32px;
        padding: 20px;
        resize: none;
        font-weight: 500;
        font-size: 16px;
      }
      .btn-submit {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 50px;
        background-color: #2e2323;
        border-radius: 5px;
        margin: 40px 38px;
        color: white;
        font-size: 18px;
        font-weight: 600;
      }
    }
  }
  @media only screen and (max-width: 600px) {
    .review-container {
      padding-left: 0;
      padding-right: 0;
    }
    .review-container__wrapper {
      padding-left: 0;
      padding-right: 0;
    }
  }
  </style>